import { Button, TextInput } from "@mantine/core";
import { useNavigate, useParams } from "react-router";
import { useForm } from "@mantine/form";
import {
  combineValidators,
  validateMinLength,
  validateNoSpaces,
  validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero,
  validateRequired,
} from "../../utils/validations";
import { creationNotification } from "../../utils/useNotification";
import Container from "./Container";
import { createEmployee } from "../../api/employeeApi";
import { ActionIcon } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";

const NewEmployee = () => {
  const navigate = useNavigate();
  const { id } = useParams(); 
  const form = useForm({
    initialValues: {
      name: "",
      phone: "",
    },
    validate: {
      name: validateRequired,
      phone: combineValidators(
        validateRequired,
        validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric,
        validateNoSpaces,
        validateMinLength(11)
      ),
    },
  });

  const handleSubmit = async (values: object) => {
    try {
      console.log("companyId:", id);        
      console.log("values:", values);
      const { data }: any = await createEmployee({
        ...values,
        companyId: id as string,
      });
      creationNotification("Çalışan ", data?.success);
      form.reset();
      navigate(`/companies/detail/${id}?tab=employee`)
    } catch (error: any) {
      console.log("companyId:", id);
      console.log("Hata:", error?.response?.status);
      console.log("Hata detayı:", error?.response?.data);
    }
  };

  return (
    <Container>
      <ActionIcon variant="subtle" color="#5c26ff" size={44} onClick={() => navigate(`/companies/detail/${id}?tab=employee`)}>
        <IconArrowLeft size={28} />
      </ActionIcon>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "70vh" }}>
        <div style={{ fontSize: "24px", fontWeight: "600", marginBottom: "20px" }}>Yeni Çalışan</div>
        <form style={{ display: "flex", flexDirection: "column", gap: "15px", width: "min(468px, 100%)" }}
          onSubmit={form.onSubmit(handleSubmit)}>
          <TextInput label="Ad Soyad" placeholder="Ad Soyad Giriniz." radius={10} size="md" maxLength={40} {...form.getInputProps("name")} />
          <TextInput label="Telefon" placeholder="Telefon Giriniz." radius={10} size="md" maxLength={11} {...form.getInputProps("phone")} />
          <Button color="#5C26FF" radius={10} type="submit">Oluştur</Button>
        </form>
      </div>
  </Container>
);
};

export default NewEmployee;
